(function () {
  const SHIPPING_COST = 0;

  const els = {
    cartItems: document.getElementById('cart-items'),
    subtotal: document.getElementById('subtotal'),
    shipping: document.getElementById('shipping'),
    total: document.getElementById('total'),
    confirmBtn: document.getElementById('confirm-order-btn'),
  };

  if (!els.cartItems || !els.subtotal || !els.shipping || !els.total || !els.confirmBtn) {
    return;
  }

  function formatPrice(value) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value || 0);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito');
    }
    return await response.json();
  }

  async function updateCartBadge() {
    const badge = document.getElementById('cart-badge');
    if (!badge) return;

    try {
      const cart = await fetchCart();
      badge.textContent = String(cart.item_count || 0);
    } catch {
      badge.textContent = '0';
    }
  }

  function renderEmptyCart() {
    els.cartItems.innerHTML =
      '<div class="empty-cart">' +
      '<div class="empty-cart__icon">🛒</div>' +
      '<h3 class="empty-cart__title">Tu carrito está vacio</h3>' +
      '<p class="empty-cart__text">No hay productos agregados.</p>' +
      '<a href="/#catalogo" class="empty-cart__link">Volver al catalogo</a>' +
      '</div>';

    els.confirmBtn.disabled = true;
    els.confirmBtn.setAttribute('aria-disabled', 'true');
    els.confirmBtn.classList.add('btn--disabled');
    els.subtotal.textContent = formatPrice(0);
    els.shipping.textContent = '¡Gratis!';
    els.total.textContent = formatPrice(0);
  }

  function renderCartItems(cart) {
    const items = cart.items || [];

    if (items.length === 0) {
      renderEmptyCart();
      return;
    }

    els.confirmBtn.disabled = false;
    els.confirmBtn.removeAttribute('aria-disabled');
    els.confirmBtn.classList.remove('btn--disabled');

    els.cartItems.innerHTML = items
      .map((item) => {
        const image = item.image || '';
        const unitPrice = (item.price || 0) / 100;
        const linePrice = (item.final_line_price || 0) / 100;
        const variant = item.variant_title || 'Variante predeterminada';
        const lineId = item.key || item.id;

        return (
          '<div class="cart-item">' +
          '<div class="cart-item__image">' +
          (image ? '<img src="' + image + '" alt="' + item.product_title + '">' : '') +
          '</div>' +
          '<div class="cart-item__content">' +
          '<h4 class="cart-item__name">' + item.product_title + '</h4>' +
          '<div class="cart-item__specs">' +
          '<span class="cart-item__spec">Variante: ' + variant + '</span>' +
          '</div>' +
          '<div class="cart-item__pricing">' +
          '<div class="cart-item__price-row">' +
          '<span class="cart-item__label">Precio unitario:</span>' +
          '<span class="cart-item__price">' + formatPrice(unitPrice) + '</span>' +
          '</div>' +
          '<div class="cart-item__price-row">' +
          '<span class="cart-item__label">Cantidad:</span>' +
          '<span class="cart-item__quantity">' + item.quantity + '</span>' +
          '</div>' +
          '<div class="cart-item__price-row cart-item__price-row--total">' +
          '<span class="cart-item__label">Subtotal:</span>' +
          '<span class="cart-item__total">' + formatPrice(linePrice) + '</span>' +
          '</div>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-remove-line="' + lineId + '">Eliminar producto</button>' +
          '</div>' +
          '<span class="cart-item__badge">' + item.quantity + '</span>' +
          '</div>'
        );
      })
      .join('');
  }

  function calculateTotals(cart) {
    const subtotal = (cart.total_price || 0) / 100;
    const shipping = SHIPPING_COST;
    const total = subtotal + shipping;

    els.subtotal.textContent = formatPrice(subtotal);
    els.shipping.textContent = shipping === 0 ? '¡Gratis!' : formatPrice(shipping);
    els.total.textContent = formatPrice(total);

    return { subtotal, shipping, total };
  }

  async function removeLineItem(lineId) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: lineId, quantity: 0 }),
    });

    if (!response.ok) {
      throw new Error('No se pudo eliminar el producto');
    }

    return await response.json();
  }

  async function renderCurrentCart() {
    const cart = await fetchCart();
    renderCartItems(cart);
    calculateTotals(cart);
    await updateCartBadge();
  }

  async function handleRemoveClick(event) {
    const button = event.target.closest('[data-remove-line]');
    if (!button) return;

    const lineId = button.getAttribute('data-remove-line');
    if (!lineId) return;

    button.disabled = true;
    button.textContent = 'Eliminando...';

    try {
      await removeLineItem(lineId);
      await renderCurrentCart();
    } catch {
      button.disabled = false;
      button.textContent = 'Eliminar producto';
      alert('No se pudo eliminar el producto. Intenta de nuevo.');
    }
  }

  async function handleConfirmOrder() {
    let cart;
    try {
      cart = await fetchCart();
    } catch {
      alert('No se pudo cargar el carrito. Intenta de nuevo.');
      return;
    }

    if (!cart.items || cart.items.length === 0) {
      alert('Tu carrito esta vacio.');
      return;
    }

    globalThis.location.href = '/checkout';
  }

  async function init() {
    try {
      await renderCurrentCart();
    } catch {
      els.cartItems.innerHTML = '<p>No se pudo cargar el carrito.</p>';
      els.confirmBtn.disabled = true;
    }

    els.confirmBtn.addEventListener('click', handleConfirmOrder);
    els.cartItems.addEventListener('click', handleRemoveClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
